module.exports = __webpack_public_path__ + "img/服务流程_m.64d2c180.png";